import {
    FETCH_RESTAURANT_CONFIG,
    CREATE_POS_TERMINAL,
} from '../../actions/types';

const INITIAL_STATE = {
    posTerminals: [],
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_RESTAURANT_CONFIG:
            return action.payload;
        case CREATE_POS_TERMINAL:
            return { ...state, posTerminals: state.posTerminals.concat(action.payload) };
        default:
            return state;
    }
};